import './BackContainer.scss'

import AngleLeft from '../Icons/AngleLeft'
import useScreenSize from '../../hooks/screen-size'

const BackContainer = ({ goBack = () => console.log('Go back!'), color = 'dark-blue', negative, secondary }) => {
  const { isDesktop } = useScreenSize()
  return !isDesktop ? (
    <div className={`back-container ${secondary} ${negative ? 'negative' : ''} nosearch`}>
      <div className="back-button" onClick={() => goBack()}>
        <AngleLeft color={negative ? 'white' : color} />
        <p>Volver</p>
      </div>
      <div className="logo-container">
        <img src={`/svg/logo-uam/logo-uam-estudiantes-${negative ? 'negative' : color}.svg`} alt="" />
      </div>
    </div>
  ) : null
}

export default BackContainer
